
<div class="text-center">
   <!-- <wl-label label="Credit score" [value]="score"></wl-label> -->
   <br>
   <p class="text-left"><b>Credit Score : {{score}}</b></p>
   <mat-progress-bar *ngIf="showWaiting" mode="buffer"> Please Wait</mat-progress-bar>
   <br>
   <!-- <button *ngIf="pdfSource" class="mybutton2" (click)="downloadPdf()">Download Credit Report</button> -->
   <button *ngIf="showButton"  class="mybutton2" (click)="downloadLink1()">Download Credit Report</button>
</div>
